/**
 * Created by yanxiaojun617@163.com on 12-27.
 */
import {Injectable} from '@angular/core';
import {
  Http, Response, Headers, RequestOptions, URLSearchParams, RequestOptionsArgs, RequestMethod
} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {Observable, TimeoutError} from "rxjs";
import {Utils} from "./Utils";
import {GlobalData} from "./GlobalData";
import {NativeService} from "./NativeService";
import { REQUEST_TIMEOUT,IS_APP} from "./Constants";
import {Logger} from "./Logger";
import {Storage} from '@ionic/storage';

@Injectable()
export class HttpService {

  constructor(public http: Http,
              public storage:Storage,
              private globalData: GlobalData,
              public logger: Logger,
              private nativeService: NativeService) {
                //this.storage.get('token');//
  }

  public request(url: string, options: RequestOptionsArgs,showLoading:boolean=true,showErrorMsg=true): Observable<Response> {
    url = Utils.formatUrl(url.startsWith('http') ? url : APP_SERVE_URL + url);
    this.optionsAddToken(options);
    return Observable.create(observer => {
      if(showLoading)
        this.nativeService.showLoading();
     //  console.log('%c 请求前 %c', 'color:blue', '', 'url', url, 'options', options);
      this.http.request(url, options).timeout(REQUEST_TIMEOUT).subscribe(res => {
        if(showLoading)
          this.nativeService.hideLoading();
        // console.log('%c 请求成功 %c', 'color:green', '', 'url', url, 'options', options, 'res', res);
        observer.next(res);
      }, err => {
        this.requestFailed(url, options, err,showErrorMsg);//处理请求失败
        observer.error(err);
      });
    });
  }

  public get(url: string, paramMap: any = null): Observable<Response> {
    return this.request(url, new RequestOptions({
      method: RequestMethod.Get,
      search: HttpService.buildURLSearchParams(paramMap)
    }));
  }

  public post(url: string, body: any = {} ,showLoading:boolean=true,showErrorMsg:boolean=true): Observable<Response> {

    return this.request(url, new RequestOptions({
      method: RequestMethod.Post,
      body: body,
      headers: new Headers({
        'Content-Type': 'application/json; charset=UTF-8'
      })
      }),showLoading,showErrorMsg
    );
  }

   public login( body: any = {}): Observable<Response> {
     //return this.post(LOGIN_URL,body);
     //如果是app则设置token 如果是 手机浏览器则设置cookie
     if(IS_APP){
       //真机器
        return this.post(LOGIN_URL,body);
     }else{
       //touch
       return this.post(LOGIN_URL_TOUCH,body);
     }
  }

  public loginOut(): Observable<Response> {
     //如果是app则设置token 如果是 手机浏览器则设置cookie
     if(IS_APP){
       //真机器
            return Observable.create(observer => {
               this.globalData.token=null;
               this.storage.remove('token');
               observer.next();
            });
     }else{
       //touch
       return this.post(LOGINOUT_URL_TOUCH);
     }
  }

  public postFormData(url: string, paramMap: any = null): Observable<Response> {
    return this.request(url, new RequestOptions({
      method: RequestMethod.Post,
      search: HttpService.buildURLSearchParams(paramMap).toString(),
      headers: new Headers({
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      })
    }));
  }

  public put(url: string, body: any = {}): Observable<Response> {
    return this.request(url, new RequestOptions({
      method: RequestMethod.Put,
      body: body
    }));
  }

  public delete(url: string, paramMap: any = null): Observable<Response> {
    return this.request(url, new RequestOptions({
      method: RequestMethod.Delete,
      search: HttpService.buildURLSearchParams(paramMap).toString()
    }));
  }

  public patch(url: string, body: any = {}): Observable<Response> {
    return this.request(url, new RequestOptions({
      method: RequestMethod.Patch,
      body: body
    }));
  }

  public head(url: string, paramMap: any = null): Observable<Response> {
    return this.request(url, new RequestOptions({
      method: RequestMethod.Head,
      search: HttpService.buildURLSearchParams(paramMap).toString()
    }));
  }

  public options(url: string, paramMap: any = null): Observable<Response> {
    return this.request(url, new RequestOptions({
      method: RequestMethod.Options,
      search: HttpService.buildURLSearchParams(paramMap).toString()
    }));
  }

  /**
   * 将对象转为查询参数
   * @param paramMap
   * @returns {URLSearchParams}
   */
  private static buildURLSearchParams(paramMap): URLSearchParams {
    let params = new URLSearchParams();
    if (!paramMap) {
      return params;
    }
    for (let key in paramMap) {
      let val = paramMap[key];
      if (val instanceof Date) {
        val = Utils.dateFormat(val, 'yyyy-MM-dd hh:mm:ss')
      }
      params.set(key, val);
    }
    return params;
  }

  /**
   * 处理请求失败事件
   * @param url
   * @param options
   * @param err
   */
  private requestFailed(url: string, options: RequestOptionsArgs, err: Response,showErrorMsg=true): void {

    this.nativeService.hideLoading();
    console.log('%c 请求失败 %c', 'color:red', '', 'url', url, 'options', options, 'err', err);
    if (err instanceof TimeoutError) {
      if(showErrorMsg)
        this.nativeService.alert('请求超时,请稍后再试!');
      return;
    }
    if (!this.nativeService.isConnecting()) {
      if(showErrorMsg)
        this.nativeService.alert('请求失败，请连接网络');
      return;
    }
    if (err.status === 401) {
        //没有登录
        // this.nativeService.alert('先去登录');
        //
        this.nativeService.login();
        return;
       
      }  
    let msg = '请求发生异常';
    try {
      let result = err.json();
       if(showErrorMsg){
           this.nativeService.alert(result.error.message || msg,result.error.details||'');
       }
    } catch (err) {
      let status = err.status;
      if (status === 0) {
        msg = '请求失败，请求响应出错';
      }else if (status === 401) {
        //没有登录
         this.nativeService.alert(msg);
        return;
       
      }  else if (status === 404) {
        msg = '请求失败，未找到请求地址';
      } else if (status === 500) {
        msg = '请求失败，服务器出错，请稍后再试';
      }
      if(showErrorMsg)
        this.nativeService.alert(msg);
      this.logger.httpLog(err, msg, {
        url: url,
        status: status
      });
    }

  }

  private optionsAddToken(options: RequestOptionsArgs): void {
    let token = this.globalData.token;
    if (options.headers) {
          options.headers.append('Authorization', 'Bearer ' + token);
       } else {
          options.headers = new Headers({
            'Authorization': 'Bearer ' + token
          });
      }
  }
}


// WEBPACK FOOTER //
// ./src/providers/HttpService.ts